import PartnerForm from "./layout"

export default PartnerForm
